import React from 'react'
import ELearningCourseLearning from '../../../modules/ELearning/Course/Learning'

const ELearningCourseLearningPage = () => {
  return <ELearningCourseLearning />
}

export default ELearningCourseLearningPage
